export const faqData = [
  {
    header: 'general',
    length: 3
  },
  {
    header: 'dashboard',
    length: 4
  },
  {
    header: 'projectsList',
    length: 4
  },
  {
    header: 'projectsPlan',
    length: 4
  },
  {
    header: 'projectsMap',
    length: 2
  },
  {
    header: 'invoices',
    length: 4
  },
  {
    header: 'pricelist',
    length: 1
  },
  {
    header: 'contacts',
    length: 3
  },
  {
    header: 'settings',
    length: 3
  },
  {
    header: 'projectDetails',
    length: 12
  },
  {
    header: 'checkout',
    length: 7
  }
]
